import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';

export const BankPromoBox = styled.div`
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 21px;
  padding: 10px 0 30px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
  }
`;

export const BankPromoButton = styled(Button)<{
  $isBirkartBanner: boolean;
  $currentLanguage: string;
}>`
  background-color: #ff0039;
  color: ${({ theme }) => theme.palette.system.white};
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  gap: 15px;
  margin: 0 auto;
  border-radius: 14px;

  ${({ $isBirkartBanner, $currentLanguage }) =>
    $isBirkartBanner &&
    css`
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('/images/birbank/birkart-${$currentLanguage}.svg');
    `}
`;
